import React, { useState } from "react";
import "./Navbar.css";

const links = [
	{ label: "Home", href: "#home" },
	{ label: "Portfolio", href: "#portfolio" },
	{ label: "Bio", href: "#bio" },
	{ label: "Skills", href: "#skills" },
	{ label: "Resume", href: "#resume" },
	{ label: "Contact", href: "#contact" },
];

function Navbar() {
	const [open, setOpen] = useState(false);

	return (
		<nav className="nav_container">
			{/* Desktop links */}
			<div className="nav_links">
				{links.map((link) => (
					<a key={link.href} className="nav_link" href={link.href}>
						{link.label}
					</a>
				))}
			</div>

			{/* Mobile hamburger */}
			<button
				className={`nav_hamburger ${open ? "nav_hamburger--open" : ""}`}
				onClick={() => setOpen(!open)}
				aria-label="Toggle navigation"
			>
				<span />
				<span />
				<span />
			</button>

			{/* Mobile drawer */}
			<div className={`nav_drawer ${open ? "nav_drawer--open" : ""}`}>
				{links.map((link) => (
					<a
						key={link.href}
						className="nav_drawer_link"
						href={link.href}
						onClick={() => setOpen(false)}
					>
						{link.label}
					</a>
				))}
			</div>
		</nav>
	);
}

export default Navbar;
